// fw Avatar — an initials square. No photos: crews are identified by initials
// on the dispatch board and that is the only thing this needs to render.

import React from 'react';
import './Avatar.css';

export const AVATAR_TONES = ['neutral', 'now', 'ok', 'sched', 'stop', 'warn'];
export const AVATAR_SIZES = ['sm', 'md', 'lg'];

export function Avatar({ initials = '', tone = 'neutral', size = 'md', className = '', ...rest }) {
  const t = AVATAR_TONES.includes(tone) ? tone : 'neutral';
  const s = AVATAR_SIZES.includes(size) ? size : 'md';
  return (
    <span
      className={['fw-avatar', `fw-avatar--${t}`, `fw-avatar--${s}`, className].filter(Boolean).join(' ')}
      data-tone={t}
      aria-hidden={rest['aria-label'] ? undefined : 'true'}
      {...rest}
    >
      {String(initials).slice(0, 2)}
    </span>
  );
}

export default Avatar;
